import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { LogoutOutlined } from "@ant-design/icons";
import {
  LoginData,
  loginUserSuccess,
  logoutUser,
  setIsMasterStore,
  setMasterStore,
  setSelectedStore,
} from "../../Redux/Action/loginAction";
import LanguageSwitcher from "../language-switcher";
import round from "../../assets/Images/roundimage.png";
import dropdown from "../../assets/Order/arrow_drop_down.svg";
import Notification from "../../assets/Notification.svg";
import { getOrderNotifications } from "../../API  Functions/Eorders";
import "../../styles.css";
import LoadingSpinner from "../Loading";
import { Dropdown, Menu, Button, Badge, Space, Drawer } from "antd";
import {
  DownOutlined,
  ShopOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import { toast } from "react-toastify";
import i18next from "i18next";
import { BellOutlined } from "@ant-design/icons";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import moment from "moment";
import "moment/locale/ar";


const setLocale = (language) => {
    if (language === 'ar') {
        moment.locale('ar');
    } else {
        moment.locale('en');
    }
};

const Navbar = ({ heading, Profile, expireDate, subStoreVersion }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const userinfo = useSelector((state) => state?.login?.user?.result);
  const isMasterStore = useSelector(
    (state) => state?.login?.user?.result?.is_master_store,
  );
  const navigate = useNavigate();
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isDropdownNotificationVisible, setisDropdownNotificationVisible] =
    useState(false);

  const [Notificationdata, setNotificationdata] = useState([]);
  const [notificationCount, setNotificationCount] = useState(null);
  const [profileName, setprofileName] = useState("Hi User");
  const [profileImage, setprofileImage] = useState("");
  const [loading, setLoading] = useState(false);

  const [subStores, setSubStores] = useState([]);
  const [loadingSubStores, setLoadingSubStores] = useState(false);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const selectedStore = useSelector((state) => state?.login?.selectedStore);

  const masterStore = useSelector((state) => state.login.masterStore);

  const location = useLocation(); // gives full location object
  const dropdownRef = useRef(null);
  const storeReducer = useSelector((state) => state?.storeReducer);

    useEffect(() => {
      getNotificationCount();
        setLocale(i18n.language);
    }, [i18n.language,notificationDrawerOpen]);

     const getNotificationCount = async () => {
    let payload = {
      company_id: userinfo?.company_id,
    };
    const response = await axiosInstance.post(URLS.UNREAD_NOTIFICATION_COUNT, payload);
    if (response?.data?.result[0]?.status_code == 200) {
      setNotificationCount(response?.data?.result[0]?.unread_count);
    }else{
      setNotificationCount(null)
    }
  };

       const handleReadNotification = async (id) => {
    let payload = {
      company_id: userinfo?.company_id,
      mark_as_all_read:false,
      notification_id:id
    };
    const response = await axiosInstance.post(URLS.MARK_READ_NOTIFICATION, payload);
    if(response?.data?.result[0]?.status_code == 200){
      // getNotificationCount()
    }
  };

  useEffect(() => {
    if (masterStore) {
      return;
    }
    const handleMasterConversion = async () => {
      try {
        if (isMasterStore) {
          const res = await getSubstores(userinfo?.company_id);

          // console.log("BNVNVNFNVNFN--->", res);

          if (res?.is_master_store && userinfo?.is_retailer) {
            // set the master store details
            dispatch(
              setMasterStore({
                store_id: userinfo.company_id,
                store_name: userinfo.company_name,
                store_email: userinfo.email,
                is_master: true,
              }),
            );

            dispatch(setIsMasterStore(true));

            const defaultStore = {
              store_id: userinfo.company_id,
              store_name: userinfo.company_name,
              store_name_ar: userinfo.company_name_ar,
              store_email: userinfo.email,
            };

            dispatch(setSelectedStore(defaultStore));
            localStorage.setItem(
              "selectedSubstore",
              JSON.stringify(defaultStore),
            );

            // console.log("✅ Master store confirmed & substores fetched:", res);
          }
        }
      } catch (err) {
        console.error("Error converting to master store:", err);
      }
    };

    handleMasterConversion();
  }, [isMasterStore]); // runs whenever this flag changes

  useEffect(() => {
    if (!userinfo) return;

    if (userinfo?.is_master_store || storeReducer) {
      // console.log("userinfo", userinfo);
      // console.log("storeReducer", storeReducer);

      fetchSubStores();
    } else {
      const defaultStore = {
        store_id: userinfo.company_id,
        store_name: userinfo.company_name,
        store_name_ar: userinfo.company_name_ar,
        store_email: userinfo.email,
      };

      dispatch(setSelectedStore(defaultStore));
      localStorage.setItem("selectedSubstore", JSON.stringify(defaultStore));
    }
  }, [subStoreVersion, userinfo, i18n.language]);

  const fetchSubStores = async () => {
    // console.log("CHALAAKAKAKAKKA");

    if (!masterStore) return;

    setLoadingSubStores(true);
    try {
      const res = await getSubstores(masterStore.store_id);
      const substoresList = res?.response || [];

      const fullStoreList = [
        masterStore,
        // ...substoresList.filter((s) => s.store_id !== masterStore.store_id ),
        ...substoresList.filter(
          (s) => s.store_id !== masterStore.store_id && s.active === true,
        ),
      ];

      // console.log("fullStoreList------->", fullStoreList);

      setSubStores(fullStoreList);

      const storedStore = JSON.parse(localStorage.getItem("selectedSubstore"));
      const defaultStore = storedStore || masterStore;
    } catch (err) {
      console.error("Error fetching substores", err);
    } finally {
      setLoadingSubStores(false);
    }
  };

  const handleStoreSelect = async (store) => {
    // Handle "All Stores" case separately
    if (store.is_select_all_store) {
      try {
        // Login using master store credentials
        const payload = { user_name: masterStore?.store_email };
        const response = await dispatch(LoginData(payload));

        if (response?.result?.status_code === 200) {
          // Prepare updated login data
          const updatedLoginData = {
            ...response,
            result: { ...response.result, is_master_store: true },
          };

          // Dispatch login success (as master)
          dispatch(loginUserSuccess(updatedLoginData));

          // Build "All Stores" selection data
          const allStoreData = {
            store_id: masterStore?.store_id,
            is_select_all_store: true,
            store_name: "All Stores",
            store_name_ar: "جميع المتاجر",
          };

          // Save to Redux and localStorage
          dispatch(setSelectedStore(allStoreData));
          localStorage.setItem(
            "selectedSubstore",
            JSON.stringify(allStoreData),
          );

          // Optionally refresh sub-stores after switching
          await fetchSubStores();

          toast.success(t("Switched to All Stores"));
          navigate("/dashboard", {
            state: { reload: Date.now() },
          });
        } else {
          toast.error(
            t(response?.result?.status || "Error switching to All Stores"),
          );
        }
      } catch (err) {
        console.error("Error switching to All Stores:", err);
        toast.error("Error switching to All Stores");
      }

      return; // Exit after handling All Stores
    }

    // Prevent re-selecting same store
    if (
      selectedStore?.store_id === store.store_id &&
      !selectedStore?.is_select_all_store
    )
      return;

    try {
      const payload = { user_name: store.store_email };
      const response = await dispatch(LoginData(payload));

      if (response?.result?.status_code === 200) {
        const updatedLoginData = {
          ...response,
          result: { ...response.result, is_master_store: true },
        };

        dispatch(loginUserSuccess(updatedLoginData));
        dispatch(setSelectedStore({ ...store, is_select_all_store: false }));
        localStorage.setItem(
          "selectedSubstore",
          JSON.stringify({ ...store, is_select_all_store: false }),
        );

        toast.success(
          `${t("Switched to")} ${
            i18next.language === "ar" ? store.store_name_ar : store.store_name
          }`,
        );

        navigate("/dashboard", {
          state: { reload: Date.now() },
        });
      } else {
        toast.error(t(response?.result?.status || "Error switching store"));
      }
    } catch (err) {
      console.error("Error switching store:", err);
      toast.error("Error switching store");
    }
  };

  const openNotificationDrawer = async () => {
    setNotificationDrawerOpen(true);
    await getorderNotifications();
  };

  const closeNotificationDrawer = () => {
    setNotificationDrawerOpen(false);
  };

  const storeMenu = (
    <Menu>
      <Menu.Item disabled>
        <Space>
          <ShopOutlined />
          <span>{t("Select Store or Warehouse")}</span>
        </Space>
      </Menu.Item>
      <Menu.Divider />

      {/* 🟢 All Stores Option */}
      {masterStore && (
        <Menu.Item
          key="all_stores"
          onClick={() =>
            handleStoreSelect({
              is_select_all_store: true,
              store_id: masterStore.store_id,
              store_name: "All Stores",
              store_name_ar: "جميع المتاجر",
            })
          }
        >
          <div className="flex justify-between items-center">
            <div className="me-4">{t("All Stores")}</div>
            {selectedStore?.is_select_all_store && (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            )}
          </div>
        </Menu.Item>
      )}

      {/* 🏬 Substores List */}
      {subStores.map((store) => (
        <Menu.Item
          key={store.store_id}
          onClick={() => handleStoreSelect(store)}
        >
          <div className="flex justify-between items-center">
            <div className="me-4">
              {i18n.language === "ar"
                ? store?.store_name_ar
                : store?.store_name}
            </div>
            {selectedStore?.store_id === store.store_id &&
              !selectedStore?.is_select_all_store && (
                <CheckCircleTwoTone twoToneColor="#52c41a" />
              )}
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  const handleToggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const handleLogout = () => {
    const currentLang = localStorage.getItem("selectedLanguage");
    localStorage.clear();
    dispatch(logoutUser());
    localStorage.setItem("selectedLanguage", currentLang);
    navigate("/login");
  };

  const getorderNotifications = async () => {
    let payload = {
      company_id: userinfo?.company_id,
      // is_read: false, //true=all read, false = unread
      limit: 20,
      offset: 0,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
    };
    const response = await axiosInstance.post(URLS.NOTIFICATIONS, payload);
    if (response?.data?.result[0]?.status_code == 200) {
      setNotificationdata(response?.data?.result[0]?.data);
    }else{
      setNotificationdata([])
    }
  };

  useEffect(() => {
    if (userinfo) {
      const companyName = userinfo?.company_name ?? "Hi User";
      setprofileName(companyName.split(" ")[0]);

      const imageUrl = userinfo?.image_url ?? "";
      setprofileImage(imageUrl || round);
    }
  }, [userinfo]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* {loading && <LoadingSpinner/>} */}

      <div className="flex items-center z-10 justify-between h-[8vh] w-full shadow-sm bg-white top-0 right-0">
        <h2
          className={`text-xl font-semibold ${
            i18n.language == "en" ? "ml-[3vh]" : "mr-[3vh]"
          }`}
        >
          {t(heading)}
        </h2>

        <div className="flex items-center">
          {expireDate && (
            <>
              <div className=" flex  my-3 mx-5 justify-end">
                <div className="px-4 py-2 items-center justify-center  text-sm font-semibold text-[#B08D15] border border-yellow-400 rounded-2xl bg-white">
                  <span>{t("Free Trial Expires on: ")}</span>{" "}
                  <span>{expireDate}</span>
                </div>
              </div>
            </>
          )}
          <div className="me-5">
            {/* Master Store Selector */}
            {(userinfo?.is_master_store || userinfo?.master_store_id) && (
              <>
                <Dropdown overlay={storeMenu} trigger={["click"]}>
                  <Button icon={<ShopOutlined />} loading={loadingSubStores}>
                    <Space>
                      {(i18n.language === "ar"
                        ? selectedStore?.store_name_ar
                        : selectedStore?.store_name) || "Select Store"}
                      {/* {selectedStore?.store_name || "Select Store"} */}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </>
            )}
          </div>
          <LanguageSwitcher setLoading={setLoading} loading={loading} />
       <div dir="ltr" className="">
          <Badge count={notificationCount} size="small" offset={[-5, 5]}>
            <Button
              type="text"
              icon={<BellOutlined style={{ fontSize: "20px" }} />}
              onClick={openNotificationDrawer}
              className=""
            />
          </Badge>
          </div>
          <div className="relative mx-4" ref={dropdownRef}>
            <button
              className="p-2 ps-1 w-40 h-10 bg-none rounded-3xl border border-[#E3E7EF] cursor-pointer flex items-center"
              onClick={handleToggleDropdown}
            >
              {profileImage ? (
                <img
                  className="me-3 h-8 w-8 object-cover rounded-full"
                  src={profileImage}
                  width={30}
                  height={30}
                  alt="Profile"
                />
              ) : (
                <img className="w-8 h-8" src={round} alt="Default Profile" />
              )}
              <p
                className={`font-medium ${
                  i18n.language == "en" ? "ms-1" : "me-1"
                }`}
              >
                {profileName}
              </p>
              <img
                className={`absolute ${
                  i18n.language == "en" ? "right-3" : "left-3"
                }`}
                src={dropdown}
                alt="Dropdown"
              />
            </button>
            {isDropdownVisible && (
              <div className="absolute w-full top-full mt-1 bg-white border rounded-lg shadow">
                <div
                  className="p-3 cursor-pointer text-sm"
                  onClick={handleLogout}
                >
                  <LogoutOutlined style={{ zIndex: 1 }} /> {t("logout")}
                </div>
              </div>
            )}
          </div>
        </div>
        {isDropdownNotificationVisible && (
          <div
            style={{
              width: "30%",
              height: "60vh",
              WebkitScrollSnapType: "block",
            }}
            className={`absolute ${
              i18n.language == "en"
                ? "float-right right-10"
                : "float-left left-10"
            } custom-scrollbar top-full ms-auto bg-[#ecebeb] border rounded-lg shadow z-50 overflow-y-scroll overflow-x-hidden`}
          >
            {Notificationdata?.length === 0 ? (
              <div className="flex h-full items-center justify-center">
                {t("No New Notifications")}
              </div>
            ) : (
              <>
                {Notificationdata?.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setisDropdownNotificationVisible(false);
                      navigate(`/Orderlist?orderDetail=${item[0]}`);
                      window.location.reload();
                    }}
                    className={`flex flex-col justify-center items-start h-10 w-80 text-xs rounded-sm mx-2 my-1 ${
                      item[1] ? "bg-[#f1f0f0]" : "bg-[#ffffff]"
                    }`}
                  >
                    <p className="flex flex-row text-black ml-2">
                      <img
                        src={Notification}
                        alt="Notification"
                        height={3}
                        width={13}
                        className="mr-2"
                      />
                      {t("new_order")}
                    </p>
                    <p className="text-[#3d3d3d] ml-2">
                      {t("new_order_note")} {item[0]}
                    </p>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
<Drawer
  title={t("Notifications")}
  placement={i18n.language == 'ar' ? 'left' :"right"}
  onClose={closeNotificationDrawer}
  open={notificationDrawerOpen}
  bodyStyle={{ padding: "12px" }}       // 🔥 reduce side padding
  width={400}
>
  {Notificationdata?.length === 0 ? (
    <div className="flex h-full items-center justify-center">
      {t("No New Notifications")}
    </div>
  ) : (
    Notificationdata?.map((item, index) => {
      const isUnread = item?.is_read === false;
      const targetDate = moment(item?.create_date);
      const timeAgo = targetDate.fromNow();

      return (
        <div
          key={index}
          onClick={() => {
            if(isUnread){
              handleReadNotification(item?.id)
            }
            closeNotificationDrawer();
            navigate("/substore/stocktransferhistory", {
              state: {
                id: item.transfer_id,
                order_no: item.order_no,
                status:item?.transfer_status,
                fromNotification: true,
              },
            });
          }}
          className={`px-4 py-2 mb-2 rounded-lg cursor-pointer border transition-all duration-200
            ${
              isUnread
                ? "bg-blue-50 border-blue-200"
                : "bg-white border-gray-200"
            }
          `}
        >
          {/* Top Row */}
          <div className="flex justify-between items-center">
            <div
              className={`text-sm font-semibold ${
                isUnread ? "text-blue-700" : "text-gray-700"
              }`}
            >
              {item?.name}
            </div>

            <div className="flex items-center gap-2">
              <span
                className={`text-xs ${
                  isUnread ? "text-blue-500" : "text-gray-400"
                }`}
              >
                {timeAgo}
              </span>

              {isUnread && (
                <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
              )}
            </div>
          </div>

          {/* 🔵 Order Number Badge
          {item?.order_no && (
            <div className="mt-2">
              <span
                className={`inline-block px-2 py-1 text-xs font-medium rounded-md
                  ${
                    isUnread
                      ? "bg-blue-100 text-blue-700"
                      : "bg-gray-100 text-gray-600"
                  }
                `}
              >
                #{item.order_no}
              </span>
            </div>
          )} */}

          {/* Message */}
          <div
            className={`text-xs mt-2 ${
              isUnread ? "text-blue-600" : "text-gray-500"
            }`}
          >
            {item?.message} {`(${item.order_no})`}
          </div>
        </div>
      );
    })
  )}
</Drawer>
      </div>
    </>
  );
};

export default Navbar;
